import api from "./auth";
import { showAlert } from "./alerts";

export default userSettings = async (obj, type) => {
  try {
    const url =
      type === "password"
        ? "/api/v1/users/updatePassword"
        : "/api/v1/users/updateMe";

    const { data } = await api.patch(url, obj);
    if (data.status === "success") {
      showAlert("success", `${type.toUpperCase()} Updated successfully!`);
    }
  } catch (error) {
    showAlert("error", error.response.data.message);
  }
};
